<template>
  <el-badge :value="noticeNum" :max="msgShowMax" :hidden="noticeNum == 0" class="badge" v-if="!msgBoxShow">
    <el-button size="small" icon="el-icon-chat-dot-round" style="font-size: 40px" @click="msgBoxShow = true" circle>
    </el-button>
  </el-badge>
  <el-container v-else>
    <el-header height="40px">
      <el-row>
        <el-col :span="20">
          系统消息({{noticeNum}})
        </el-col>
        <el-col :span="4" class="text-right">
          <el-link :underline="false" @click="msgBoxShow = false">
            <i class="el-icon-close" />
          </el-link>
        </el-col>
      </el-row>
    </el-header>
    <el-main v-loading="dataListLoading">
      <el-link v-for="item in dataList" :key="item.id" @click="HandleMsg(item)" class="text">
        <el-row class="textBody">
          <el-col>
            [{{formatValue(item.kind,'msgKind')}}]{{item.msgBody}}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" class="text-left">{{item.userName}}</el-col>
          <el-col :span="12" class="text-right">{{item.updateTime | dateTimeFormat}}</el-col>
        </el-row>
      </el-link>
    </el-main>
    <el-footer height="40px">
      <el-row>
        <el-col :span="12">
          <el-switch
            inactive-text="通知开关" v-model="msgSwitch"
            active-color="#ff4949" inactive-color="#13ce66">
          </el-switch>
        </el-col>
        <el-col :span="6" class="text-left">
          <el-link :underline="false" @click="HandleViewAll()">查看全部</el-link>
        </el-col>
        <el-col :span="6" class="text-right">
          <el-link :underline="false" @click="HandleReadAll()">全部已读</el-link>
        </el-col>
      </el-row>
    </el-footer>
    <read-view v-if="readViewVisible" ref="readView" @refreshDataList="getDataList"></read-view>
  </el-container>
</template>

<script>
  import readView from './notice-view'
  export default {
    data() {
      return {
        interval: null,
        intervalTime: 60000,
        msgShowMax: 20,
        noticeNum: 0,
        msgBoxShow: false,
        msgSwitch: false,
        dataList: [],
        dataListLoading: false,
        readViewVisible: false
      }
    },
    name: "notice-drawer",
    components: {
      readView
    },
    mounted() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.interval = setInterval(() => {
        if (!this.msgSwitch) {
          this.getDataList();
        }
      }, this.intervalTime)
    },
    created() {
      this.msgSwitch = false;
      this.getDataList();
    },
    activated() {
    },
    beforeDestroy() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    deactivated() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    methods: {
      getDataList() {
        this.dataListLoading = true
        this.$http({
          url: this.$http.adornUrl('/message/notice/list'),
          method: 'post',
          data: this.$http.adornData({
            pageIndex: 1,
            pageSize: this.msgShowMax,
            flag: 1
          })
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.dataList = data.data.list
            this.noticeNum = data.data.totalCount
          } else if (data && data.code === 401 ) {
            console.warn("notice list stop, because token is expire!")
            if (this.interval) {
              clearInterval(this.interval);
              this.interval = null;
            }
          } else {
            this.dataList = []
            this.noticeNum = 0
          }
          this.dataListLoading = false;
        })
      },
      HandleMsg(row) {
        this.readViewVisible = true
        this.$nextTick(() => {
          this.$refs.readView.init(row)
        })
/*        var id =1;
        this.$confirm(`确定进行${id ? '[删除]' : '[批量删除]'}操作?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })*/

        /*if (item.url != undefined && item.url != null) {
          this.$router.push({name: item.url})
        } else {

        }*/
      },
      HandleViewAll() {
        this.$router.push({name: "message-notice"})
        this.msgBoxShow = false
      },
      HandleReadAll() {
        if (this.dataList.length > 0) {
          let ids = [];
          this.dataList.forEach(item => {
            ids.push(item.id)
          })
          this.$http({
            url: this.$http.adornUrl('/message/notice/read'),
            method: 'post',
            data: this.$http.adornData(ids, false)
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      }
    }
  };
</script>

<style scoped>
  .badge {
    margin-bottom: 20px;
    margin-right: 40px;
  }
  .el-container {
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    width: 350px;
    max-height: 350px;
  }

  .el-header {
    background-color: #8FA2C1;
    width: 100%;
    color: #fff;
    text-align: left;
    line-height: 40px;
    font-size: 16px;
  }
  .el-footer {
    background-color: #D9DEE6;
    width: 100%;
    color: #333;
    text-align: left;
    line-height: 40px;
    font-size: 14px;
  }

  .el-main {
    min-height:5px;
    background-color: #E9EEF3;
    color: #333;
    line-height: 25px;
    padding: 0px;
    overflow-x: hidden;
  }

  .text {
    font-size: 14px;
    height: 51px;
    text-align: left;
    font-size: 14px;
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;
    padding: 1px 5px;
  }
  .textBody {
    width: 340px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .text-left {
    text-align: left;
  }

  .text-right {
    text-align: right;
  }

</style>



// WEBPACK FOOTER //
// src/components/notice-drawer/notice-drawer.vue